import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { LifeBuoy } from 'lucide-react'
import { SupportAccessScreen } from '@/screens/org/SCR-144-support-access'

export const Route = createFileRoute('/_app/org/support-access')({
  staticData: { screen: { id: 'SCR-144', title: 'Support access', group: 'Organisation', perm: 'identity.manage', order: 6, description: 'Let Adya support look at your organisation, for a limited time and at the level you choose.', icon: LifeBuoy } },
  validateSearch: z.object({
    grant: z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean()).optional().catch(undefined),
  }),
  component: SupportAccessScreen,
})
